export default __webpack_public_path__ + "static/media/mobile_3.a7255cb1.png";